import { useEffect, useState } from 'react';

import { useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { getCookieAsBoolean } from '@zg-rentals/zillow-rental-manager/client';

import { ZRM_AI_IMAGE_LISTING_COMPLIANCE_ENABLED } from '../../constants/FeatureFlagConstants';

export const AI_IMAGE_LISTING_COMPLIANCE_DETAILS_TAG = 'ai-image-listing-compliance-details';

/** Gate for all AI image listing compliance UI. Which states apply is decided by the backend, not here. */
export const useAiImageListingCompliance = ({
  listingAlias,
  enabled = true,
}: {
  listingAlias: string;
  enabled?: boolean;
}) => {
  const [isCookieEnabled, setIsCookieEnabled] = useState(false);

  useEffect(() => {
    setIsCookieEnabled(getCookieAsBoolean(ZRM_AI_IMAGE_LISTING_COMPLIANCE_ENABLED));
  }, []);

  const { data, isLoading } = useRentalManagerUserPropertyDigitallyAlteredPhotosWebApiHandler_details(
    { listingAlias },
    {
      enabled: enabled && Boolean(listingAlias),
      meta: {
        tags: [AI_IMAGE_LISTING_COMPLIANCE_DETAILS_TAG, listingAlias],
        context: {
          api: 'digitallyAlteredPhotosDetails',
          details: { listingAlias },
        },
      },
    },
  );

  return {
    isEnabled: isCookieEnabled || Boolean(data?.isEnabled),
    isAttestationCompleted: data?.isAttestationCompleted ?? false,
    isLoading,
  };
};
